<template>
  <v-container
    fluid
    class="mp-request-detail">
    <v-layout>
      <router-link
        :to="'/masterpayer-request/view'"
        class="view-link">
        <v-btn>Back to List</v-btn>
      </router-link>
    </v-layout>
    <material-card class="px-3">
      <div v-if="masterpayerRequestDetailLoading" class="disabled-section"></div>
      <v-progress-linear
        v-if="masterpayerRequestDetailLoading"
        color="orange"
        indeterminate/>
      <v-layout row wrap>
        <v-flex
          md10
          pt-2
          class="d-flex align-center">
          <label>Will this be a customer dedicated Master account?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md2>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-btn-toggle v-model="masterpayerRequestDetail.dedicatedMasterAccount" >
                <v-btn
                  value="Yes"
                  class="black--text btn--qa">Yes</v-btn>
                <v-btn
                  value="No"
                  class="black--text btn--qa">No</v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md12>
          <v-layout v-if="masterpayerRequestDetail.dedicatedMasterAccount=='Yes'">
            <v-flex
              pl-5
              sm12
              md6>
              <label>Please provide the Client's name and SFID ID</label>
              <v-layout align-center mb-2>
                <v-flex md3>
                  <label>Client's Name: <span class="required">*</span></label>
                </v-flex>
                <v-flex md9>
                  <v-text-field
                    hide-details
                    v-model="masterpayerRequestDetail.clientName"
                    placeholder="Client Name"
                    name="Client_Name"
                    solo
                  />
                </v-flex>
              </v-layout>
              <v-layout align-center>
                <v-flex md3>
                  <label>Client's SFDC ID: <span class="required">*</span></label>
                </v-flex>
                <v-flex md9>
                  <v-text-field
                    hide-details
                    v-model="masterpayerRequestDetail.clientSfdcid"
                    placeholder="Client Name"
                    name="Client_Name"
                    solo
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout v-if="masterpayerRequestDetail.dedicatedMasterAccount=='No'">
            <v-flex
              pl-5
              sm12
              md6>
              <label>Will this be for DXC Interanl buisness? If yes, Provide the service line and BU</label>
              <v-layout align-center mb-2>
                <v-flex md3>
                  <label>Service Line: <span class="required">*</span></label>
                </v-flex>
                <v-flex md9>
                  <v-text-field
                    hide-details
                    v-model="masterpayerRequestDetail.serviceLine"
                    placeholder="Service Line"
                    name="Service_Line"
                    solo
                  />
                </v-flex>
              </v-layout>
              <v-layout align-center>
                <v-flex md3>
                  <label>Business Unit: <span class="required">*</span></label>
                </v-flex>
                <v-flex md9>
                  <v-text-field
                    hide-details
                    v-model="masterpayerRequestDetail.businessUnit"
                    placeholder="Business Unit"
                    name="Business_Unit"
                    solo
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap align-center>
                <v-flex
                  md8
                  pt-2
                  class="d-flex align-center">
                  <label>Is this delivered under the SaaS model?
                    <span class="required">*</span>
                  </label>
                </v-flex>
                <v-flex
                  md4>
                  <v-layout 
                    column
                    align-end>
                    <v-flex>
                      <v-btn-toggle v-model="masterpayerRequestDetail.saasModel" >
                        <v-btn
                          value="Yes"
                          class="black--text btn--qa">Yes</v-btn>
                        <v-btn
                          value="No"
                          class="black--text btn--qa">No</v-btn>
                      </v-btn-toggle>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex
          md7
          pt-2>
          <label>What is the account model for this dedicated Master Account?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md5>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-radio-group row v-model="masterpayerRequestDetail.accountModel" >
                <v-radio
                  color="primary"
                  label="SPP"
                  value="SPP"
                />
                <v-radio
                  color="primary"
                  label="PPA"
                  value="PPA"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md6 v-if="masterpayerRequestDetail.accountModel=='PPA'">
          <v-layout>
            <v-flex
              pl-5
              sm12
              md12>
              <label>Please specify business justification:<span class="required">*</span></label>
              <v-textarea 
                v-model="masterpayerRequestDetail.businessJustification"
                placeholder="Business Justification"
                solo />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="masterpayerRequestDetail.dedicatedMasterAccount=='Yes'" row wrap  align-center>
        <v-flex
          md7>
          <label>What is the contract type for this SPP Master Account?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md5>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-radio-group row v-model="masterpayerRequestDetail.sppContractType" >
                <v-radio
                  color="primary"
                  label="Partner"
                  value="Partner"
                />
                <v-radio
                  color="primary"
                  label="Resold"
                  value="Resold"
                />
                <v-radio
                  color="primary"
                  label="Ecam Partner"
                  value="Ecam Partner"
                />
                <v-radio
                  color="primary"
                  label="Ecam Resold"
                  value="Ecam Resold"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          md6
          pt-2
          class="flex-column">
          <label class="d-block">What AWS Support level is required for this dedicated Master Account?
            <span class="required">*</span>
          </label>
          <small>Note - All lined accounts will same support as their Master Payer</small>
        </v-flex>
        <v-flex
          md6>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-radio-group row v-model="masterpayerRequestDetail.awsSupportLevel" >
                <v-radio
                  color="primary"
                  label="Enterprise"
                  value="Enterprise"
                />
                <v-radio
                  color="primary"
                  label="Developer"
                  value="Developer"
                />
                <v-radio
                  color="primary"
                  label="Business"
                  value="Business"
                />
                <v-radio
                  color="primary"
                  label="Basic"
                  value="Basic"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row align-center>
        <v-flex
          md6
          pt-2
          class="flex-column">
          <label class="d-block">Will the linked accounts for this Master Payer be:
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md6>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-radio-group v-model="masterpayerRequestDetail.linkedAccountsType" >
                <v-radio
                  color="primary"
                  label="New DXC-created Linked (Child) accounts"
                  value="New"
                />
                <v-radio
                  color="primary"
                  label="Accounts transferred from the customer (ShareShift)"
                  value="Transferred"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          md9
          pt-2
          class="d-flex align-center">
          <label>What is the contract signature date?  What date do services begin?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md3>
          <v-menu
            v-model="contractSignatureDateModal"
            :close-on-content-click="false"
            :nudge-left="200"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="masterpayerRequestDetail.contractSignatureDate"
                label="Contract Signature Date"
                prepend-icon="event"
                clearable
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="masterpayerRequestDetail.contractSignatureDate"
              @input="contractSignatureDateModal = false"/>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row align-center>
        <v-flex
          md8
          pt-2
          class="d-flex align-center">
          <label>What is your Opportunity Registration / Opportunity ID?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md4>
          <v-text-field
            hide-details
            v-model="masterpayerRequestDetail.opportunityId"
            placeholder="Opportunity ID"
            name="Opportunity_ID"
            solo
          />
        </v-flex>
      </v-layout>
      <v-layout row align-center>
        <v-flex
          md10
          pt-2
          class="flex-column">
          <label class="d-block">Does this customer have it’s own EDP contract?
            <span class="required">*</span>
          </label>
          <small>Note: edp = Enterprise Discount Plan, master account for a specific customer or group of customers under a dedicated AWS agreement (not the DXC PPA or SPP agreements)</small>
        </v-flex>
        <v-flex
          md2>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-btn-toggle v-model="masterpayerRequestDetail.edpContract" >
                <v-btn
                  id="q9"
                  value="Yes"
                  class="black--text btn--qa">Yes</v-btn>
                <v-btn
                  value="No"
                  class="black--text btn--qa">No</v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex
          md10
          pt-2
          class="d-flex align-center">
          <label>Is there a Control tower required as part of MP?
            <span class="required">*</span>
          </label>
        </v-flex>
        <v-flex
          md2>
          <v-layout 
            column
            align-end>
            <v-flex>
              <v-btn-toggle v-model="masterpayerRequestDetail.controlTowerRequired" >
                <v-btn
                  value="Yes"
                  class="black--text btn--qa">Yes</v-btn>
                <v-btn
                  value="No"
                  class="black--text btn--qa">No</v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md12>
          <v-layout v-if="masterpayerRequestDetail.controlTowerRequired=='Yes'">
            <v-flex
              pl-5
              sm12
              md6>
              <label>What are the regions they want to enable control tower?</label>
              <v-layout align-center mb-2>
                <v-flex md12>
                  <v-autocomplete
                    v-model.lazy="masterpayerRequestDetail.controlTowerRegions"
                    :hint="'Select regions. Click the icon on the right to view the full list'"
                    :items="awsRegions"
                    persistent-hint
                    style="margin-top: 0; padding-top: 5px"
                    open-on-clear
                    attach
                    multiple
                    chips
                    small-chips
                    solo
                  >
                    <!-- <template v-slot:selection="data">
                      {{ data.item }}
                    </template> -->
                    <!-- <template v-slot:append-outer>
                      <v-icon
                        color="orange"
                        @click="onFullView"
                        v-text="'mdi-view-list'"
                      ></v-icon>
                    </template> -->
                  </v-autocomplete>

                  <!-- <v-text-field
                    hide-details
                    v-model="masterpayerRequestDetail.controlTowerRegions"
                    placeholder="Regions"
                    name="Regions"
                    solo
                  /> -->
                </v-flex>
              </v-layout>
              <v-layout align-center>
                <v-flex md6>
                  <label>Guard Rail?</label>
                </v-flex>
                <v-flex md6>
                  <v-radio-group row v-model="masterpayerRequestDetail.controlTowerGuardRail" >
                    <v-radio
                      color="primary"
                      label="Yes"
                      value="Yes"
                    />
                    <v-radio
                      color="primary"
                      label="No"
                      value="No"
                    />
                  </v-radio-group>    
                </v-flex>
              </v-layout>
              <v-layout align-center>
                <v-flex md6>
                  <label>Cloud Trail?</label>
                </v-flex>
                <v-flex md6>
                  <v-radio-group row v-model="masterpayerRequestDetail.controlTowerGuardRail" >
                    <v-radio
                      color="primary"
                      label="Yes"
                      value="Yes"
                    />
                    <v-radio
                      color="primary"
                      label="No"
                      value="No"
                    />
                  </v-radio-group>    
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <h4>Attestation</h4>
      <v-layout row wrap>
        <v-flex
          md6>
          <v-text-field
            v-model="masterpayerRequestDetail.requestorName"
            label="Requestor Name"
            solo
          />
        </v-flex>
        <v-flex
          md6>
          <v-text-field
            v-model="masterpayerRequestDetail.requestorEmail"
            label="Requestor Email"
            solo
          />
        </v-flex>
      </v-layout>
    </material-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    contractSignatureDateModal: false,
    incompleteInputs: false,
    awsRegions: ['us-east-1', 'us-east-2', 'us-west-1', 'us-west-2', 'ca-central-1', 'eu-west-1', 'eu-central-1', 'eu-west-2', 'eu-west-3', 'eu-north-1', 'ap-northeast-1', 'ap-northeast-2', 'ap-southeast-1', 'ap-southeast-2', 'ap-south-1', 'sa-east-1', 'us-gov-west-1', 'us-gov-east-1']
  }),
  computed: {
    ...mapState('admin/masterpayerOnboarding', ['masterpayerRequestDetail', 'masterpayerRequestDetailLoading', 'masterpayerStatusLoading'])
  },
  mounted () {
    this.$store.dispatch('admin/masterpayerOnboarding/getMasterpayerRequestDetail', this.$route.params.id)
  },
  methods: {
    onStatusUpdate() {
      this.$store.dispatch('admin/masterpayerOnboarding/setMasterpayerStatus', { id: this.$route.params.id, status: this.masterpayerRequestDetail.Status})
    }
  }
}
</script>

<style lang="scss" scoped>

.mp-request-detail {
  .v-btn-toggle{ margin:10px 0}
  .v-btn-toggle .v-btn{
    padding: 15px 38px;
    opacity: 1;
  }
  
  .btn--qa{
    font-weight: bold !important;
  }

  .v-select--width{
    width: 100%;
  }

  span{
    &.workload-desc{
      font-weight:600
    }
  }

  .disabled-section {
    background: #f5f5f5;
    width: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 99;
    height: 100%;
    opacity: 0.7;
  }
}

</style>